import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeodestinosService } from '@cms-app/geodestinos';
var AdminHotelsComponent = /** @class */ (function () {
    function AdminHotelsComponent(router, geodestinosService) {
        this.router = router;
        this.geodestinosService = geodestinosService;
        this.rows = [];
        this.count = 0;
        this.page = 1;
        this.per_page = 20;
        this.query = '';
        this.loading = false;
    }
    AdminHotelsComponent.prototype.ngOnInit = function () {
        this.find();
    };
    AdminHotelsComponent.prototype.checkLink = function (row) {
        window.open(row.url, '_blank');
    };
    AdminHotelsComponent.prototype.update = function (row) {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'alojamiento', row._id], {
            state: {
                data: row,
                type: 'alojamiento'
            }
        });
    };
    AdminHotelsComponent.prototype.onPage = function (_a) {
        var offset = _a.offset;
        this.page = offset + 1;
        this.find();
    };
    AdminHotelsComponent.prototype.onQuery = function (query) {
        this.query = query;
        this.find();
    };
    AdminHotelsComponent.prototype.find = function () {
        var _this = this;
        this.loading = true;
        this.geodestinosService
            .fetch('alojamiento', this.query && this.query.length > 0 ? { q: this.query } : {}, { page: this.page || 1, per_page: this.per_page })
            .subscribe(function (_a) {
            var list = _a.list, count = _a.count;
            _this.rows = list;
            _this.count = count;
            _this.loading = false;
        }, function () {
            _this.loading = false;
        });
    };
    AdminHotelsComponent.prototype.onAdd = function () {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'alojamiento', 'new']);
    };
    return AdminHotelsComponent;
}());
export { AdminHotelsComponent };
